import { PickList } from "primereact/picklist";
import { useEffect, useState } from "react";
import { Col,  Row } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { AiOutlineFolder } from "react-icons/ai";
import { getGroupedItemManager } from "../../../../../services/item.service";
import { UnityAccordion } from "../../../../base/discipline/components/unity-accordion";
import { CardDescription} from "../../../styled"
import { CustomPickList } from "./styled";

export function PickListForm(props: any) {
    const { t: translation } = useTranslation();

    const { updateData = false, itemData, handleSetValue } = props;

    const [source, setSource] = useState([]);
    const [target, setTarget] = useState([]);

    const onChange = (event: any) => {
        setSource(event.source);
        setTarget(event.target);
        handleSetValue('discipline_items', event.source)
    }

    useEffect(() => {
        getGroupedItemManager().then(data => {
            setTarget(data);
        })
    }, [])

    useEffect(() => {
        if (itemData && itemData.items) {
            setSource(itemData.items);
            handleSetValue('discipline_items', itemData.items)
        }
    }, [itemData])

    const itemTemplate = (item: any) => {
        return (
            <Row className="product-details">
                <Col md={2} className="pr-0">
                    <div className={`product-badge type-${item.is_theme ? 'theme' : 'item'}`}>{item.is_theme ? ' Tema' : 'Unidade'}</div>
                </Col>
                <Col md={10}>
                    <h6 className="product-title mb-2">{item.title}</h6>
                </Col>
            </Row>
        );
    }

    return (
        <>
            <CardDescription>
                <CustomPickList>
                    <div className="title mb-3"><AiOutlineFolder fontSize={20} style={{ marginTop: '-5px' }}></AiOutlineFolder> {translation('material.units')}</div>

                    {updateData ? (<>
                        <PickList source={source} target={target} itemTemplate={itemTemplate}
                            onChange={onChange} sourceHeader="Vinculados" targetHeader="Unidades Disponíveis"
                            showSourceControls={false} showTargetControls={false} className="w-100"
                        />
                    </>) : (<>
                        {(() => {
                            if (itemData?.items) {
                                return (
                                    <UnityAccordion key={itemData.id} unities={itemData?.items}></UnityAccordion>
                                )
                            }

                            return null;
                        })()}

                        {itemData?.items?.length === 0 ? (
                            <h6>{translation('notFound.discipline')}</h6>
                        ) : (
                            <></>
                        )}

                    </>)}
                </CustomPickList>
            </CardDescription>
        </>
    )
}